import React from 'react';
import { Link } from 'react-router-dom';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useI18n } from '../../contexts/I18nContext';
import memberDrawerStyles from '../Styles/MemberDrawer.Style';

const DrawerListItem = React.memo(({ to, labelKey, getListItemStyles }) => {
  const i18n = useI18n();

  return (
    <Link to={to}>
      <ListItem
        button
        sx={getListItemStyles(to.replace('/', ''))}
      >
        <ListItemText
          sx={(theme) => memberDrawerStyles.itemTextCtr(theme)}
          primary={i18n.t(labelKey)}
        />
      </ListItem>
    </Link>
  );
});

DrawerListItem.displayName = 'DrawerListItem';

export default DrawerListItem;